import { useState, useCallback } from "react";

type FormData = Record<string, any>;

export function useMultiStepFormData() {
  const [formData, setFormData] = useState<FormData>({});

  // Guarda o actualiza un step
  const saveStepData = useCallback((stepId: string, values: any) => {
    setFormData((prev) => ({
      ...prev,
      [stepId]: values,
    }));
  }, []);

  // Recupera valores de un step (útil para defaultValues)
  const getStepData = useCallback(
    (stepId: string) => formData[stepId] || {},
    [formData]
  );

  // Retorna el objeto completo
  const getAllData = useCallback(() => formData, [formData]);

  // Reset (por ejemplo al reiniciar el wizard)
  const resetData = useCallback(() => setFormData({}), []);

  return {
    formData,
    saveStepData,
    getStepData,
    getAllData,
    resetData,
  };
}
